import React from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'
import {
  Form,
  Button
} from 'semantic-ui-react'

const propStr = prop => R.compose(
  R.defaultTo(''),
  R.prop(prop)
)

const getName = propStr('name')
const getContactEmail = propStr('contact_email')
const getContactName = propStr('contact_name')
const getContactPhone = propStr('contact_phone')
const getDescription = propStr('description')
const getNetsuiteId = propStr('netsuite_id')

const ResellerProfile = ({
  profile,
  dirty,
  onChange,
  onCancel,
  onSubmit,
  readOnly
}) => {

  return (
    <Form size='tiny' onSubmit={onSubmit}>
      <Form.Group>
        <Form.Input readOnly={ readOnly } width={8} label='Name' name='name' placeholder='Name' value={getName(profile)} onChange={onChange} />
        <Form.Input
          width={8}
          readOnly={ readOnly }
          label='Description'
          name='description'
          placeholder='Description'
          value={getDescription(profile)}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Input
          width={5}
          readOnly={ readOnly }
          label='Contact Name'
          name='contact_name'
          placeholder='Contact Name (required)'
          value={getContactName(profile)}
          onChange={onChange}
        />
        <Form.Input
          width={5}
          readOnly={ readOnly }
          label='Contact Email'
          name='contact_email'
          placeholder='Email (required)'
          value={getContactEmail(profile)}
          onChange={onChange}
          type='email' />
        <Form.Input readOnly={ readOnly } width={6} label='Contact Phone' name='contact_phone' placeholder='Phone' value={getContactPhone(profile)} onChange={onChange} />
      </Form.Group>
      <Form.Group>
        <Form.Field width={5}>
          <Form.Input
            readOnly={ readOnly }
            label='Xero ID'
            name='xero_id'
            placeholder='Xero ID (please enter the UUID from Xero)'
            value={profile.xero_id}
            onChange={onChange}
          />
          {profile.xero_id ? (
            <p style={{ paddingTop: "8px" }}>
              <a href={`https://go.xero.com/Contacts/View/${profile.xero_id}`} target="_blank" rel="noopener noreferrer">
                To Xero Account »
              </a>
            </p>
          ) : null}
        </Form.Field>
        <Form.Field width={5}>
          <Form.Input
            readOnly={ readOnly }
            label='Capsule ID'
            name='capsule_id'
            placeholder='Capsule ID (please enter the ID from Capsule)'
            value={profile.capsule_id}
            onChange={onChange}
          />
          {profile.capsule_id ? (
            <p style={{ paddingTop: "8px" }}>
              <a href={`https://cycling74.capsulecrm.com/party/${profile.capsule_id}`} target="_blank" rel="noopener noreferrer">
                To Capsule Account »
              </a>
            </p>
          ) : null}
        </Form.Field>
        <Form.Input
          width={6}
          readOnly={ readOnly }
          label='Netsuite Id'
          name='netsuite_id'
          placeholder='Netsuite id (please enter the former netsuite id)'
          value={getNetsuiteId(profile)}
          onChange={onChange}
        />
      </Form.Group>
      {
        !readOnly ? (
          <Button.Group>
            <Button disabled={!dirty} onClick={onCancel}>Cancel</Button>
            <Button.Or />
            <Button positive={dirty} disabled={!dirty} type="submit">Save</Button>
          </Button.Group>
        ) : null
      }
    </Form>
  );
}

ResellerProfile.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  dirty: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired
}

export default ResellerProfile



// WEBPACK FOOTER //
// ./webAdmin/forms/resellerProfileForm.js